module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/True-Detective-S3.41b2ba0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/True-Detective-S3.jpg
// module id = THNc
// module chunks = 0